export const UI_ACTIONS = {
    CHANGE: 'ui/CHANGE'
};

const defaultState = {
    devEdit: true // process.env.NODE_ENV === 'dev'
};

const reducer = (state = defaultState, action) => {
    const { key, value, type } = action;
    switch (type) {
        case UI_ACTIONS.CHANGE:
            return { ...state, ...{ [key]: value } };
        default:
            return state;
    }
};

export default reducer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/reducers/ui.js
 **/